import { render, staticRenderFns } from "./StepReviewPresses.vue?vue&type=template&id=5cecd2d0&scoped=true&"
import script from "./StepReviewPresses.vue?vue&type=script&lang=js&"
export * from "./StepReviewPresses.vue?vue&type=script&lang=js&"
import style0 from "./StepReviewPresses.vue?vue&type=style&index=0&id=5cecd2d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cecd2d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAlert,VDivider})
